import { render, staticRenderFns } from "./ModalAnswerObservationReviewer.vue?vue&type=template&id=a163f64e"
import script from "./ModalAnswerObservationReviewer.vue?vue&type=script&lang=js"
export * from "./ModalAnswerObservationReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports